import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_PHP_API_URL,
  withCredentials: true
});

// Attach JWT token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
